import { get_day_info as e } from "./get_day_info.js";
import { get_eng_day_info as t } from "./get_eng_day_info.js";
import { get_first_day_of_the_month as n } from "./get_first_day_of_the_month.js";
import { get_next_decade_date as r } from "./get_next_decade_date.js";
import { get_next_month_date as i } from "./get_next_month_date.js";
import { get_next_year_date as a } from "./get_next_year_date.js";
import { get_normalized_date as o } from "./get_normalized_date.js";
import { get_previous_decade_date as s } from "./get_previous_decade_date.js";
import { get_previous_month_date as c } from "./get_previous_month_date.js";
import { get_previous_year_date as l } from "./get_previous_year_date.js";
import { get_total_days_in_month as u } from "./get_total_days_in_month.js";
import { get_weeks_in_month as d } from "./get_weeks_in_month.js";
import { is_date_valid as f } from "./is_date_valid.js";
import { is_today as p } from "./is_today.js";
import { validate_date_in_range as m } from "./validate_date_in_range.js";
// src/design/forms/datepicker/calendar-engine/use-cases/english_date/index.ts
var h = {
	get_number_of_days_in_BS_month: void 0,
	previous_month: void 0,
	previous_month_days: void 0,
	previous_year: void 0,
	get_day_info: e,
	get_first_day_of_the_month: n,
	get_total_days_in_month: u,
	get_weeks_in_month: d,
	get_normalized_date: o,
	get_eng_day_info: t,
	get_next_month_date: i,
	get_previous_month_date: c,
	get_next_year_date: a,
	get_previous_year_date: l,
	get_previous_decade_date: s,
	get_next_decade_date: r,
	is_today: p,
	is_date_valid: f,
	validate_date_in_range: m
};
export { h as ENGLISH_DATE };

//# sourceMappingURL=index.js.map